import { Dispatch, useMemo } from 'react';

import { CloseOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Flex, Input, Tooltip, Typography } from 'antd';

import style from '../../styles.module.css';

import { TActiveMenuTab } from '../..';
import TranscriptionText from '../TranscriptionText';
import { mockData2 } from '../data';

interface TProps {
	data?: any;
	search: string;
	setSearch: Dispatch<string>;
	activeTab: TActiveMenuTab;
	item: any;
}

type TVideoData = typeof mockData2;

export default function Transcript({
	search,
	setSearch,
	activeTab,
	item,
}: TProps) {
	const videoData: TVideoData = item;

	const transcription =
		videoData?.content?.transcription?.baseTranscription?.text;

	const matchAmountFound = useMemo(() => {
		if (!transcription || !search?.trim()?.length) return 0;

		const searchRegex = new RegExp(search, 'gi');
		const matches = transcription?.match(searchRegex);
		return matches ? matches.length : 0;
	}, [search, transcription]);

	if (activeTab !== 'transcript') {
		return null;
	}

	return (
		<Flex vertical className={style.scrollableWrapper}>
			<>
				{transcription?.length > 1 && (
					<Flex vertical style={{ marginBottom: '0.25rem' }}>
						<Flex className={style.searchWrapper} gap={8} align="center">
							<Typography.Text style={{ display: 'block', wordBreak: 'unset' }}>
								Search
							</Typography.Text>
							<Input
								value={search}
								onChange={(e) => setSearch(e.target.value)}
								placeholder="Type to search"
								allowClear
							/>
							{/* {search?.trim()?.length > 0 ? (
								<Tooltip title="Clear search">
									<Button
										onClick={() => setSearch('')}
										type="text"
										icon={<CloseOutlined />}
										className={style.clearSearchButton}
									/>
								</Tooltip>
							) : ( */}
							<SearchOutlined className={style.searchIcon} />
							{/* )} */}
						</Flex>
						<Typography.Text className={style.searchResultText}>
							{search?.trim()?.length > 0 ? (
								<>
									{matchAmountFound > 0
										? `${matchAmountFound} match${
												matchAmountFound > 1 ? 'es' : ''
										  } found`
										: 'No matches found'}
								</>
							) : (
								' '
							)}
						</Typography.Text>
					</Flex>
				)}
				{transcription?.length > 1 ? (
					<TranscriptionText text={transcription} searchTerm={search} />
				) : (
					<span style={{ color: 'gray' }}>n/a</span>
				)}
			</>
		</Flex>
	);
}
